import { store } from "infrastructure/store/ConfigureStore";
import { setGridSortingUrlParams } from "infrastructure/store/dataGrid/DataGridActions";
import { injectable } from "inversify";
import ISortingStoreHandler from "./ISortingStoreHandler";

@injectable()
export default class SortingStoreHandler implements ISortingStoreHandler {
  storeSetDefaultSorting(
    dataGridId: string,
    activeSortingParams: string,
    defaultSortingParams: string
  ): void {
    let urlSearchParams: string = "";

    if (activeSortingParams) {
      urlSearchParams = activeSortingParams;
    } else if (defaultSortingParams) {
      urlSearchParams = defaultSortingParams;
    }

    store.dispatch(
      setGridSortingUrlParams({
        key: dataGridId,
        value: urlSearchParams
      })
    );
  }

  storeChangeSorting(dataGridId: string, activeSortingParams: string): void {
    store.dispatch(
      setGridSortingUrlParams({
        key: dataGridId,
        value: activeSortingParams
      })
    );
  }
}
